export default __webpack_public_path__ + "static/media/1785.f4e9891c.png";